exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code-redeem__form-item--important .ant-form-item-control-wrapper {\n  font-weight: bold;\n  font-size: 16px;\n}\n.code-redeem__form-item--most-important {\n  font-weight: bold;\n  font-size: 16px;\n}\n", ""]);

// exports
